import React from "react";

const MenuUploadDownload = ({
  onDownloadEnglishMenu,
  onDownloadHindiMenu,
  onUploadEnglishMenu,
  onUploadHindiMenu,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
      <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Manage your menu from here
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Upload Hindi Menu Card */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg border border-blue-100 hover:border-blue-200 transition duration-300">
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 mx-auto text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
              />
            </svg>
            <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Upload Indian Menu
            </h4>
            <p className="text-gray-600 mt-2 mb-4">
              Upload your Indian menu in Excel format.
            </p>
            <input
              type="file"
              id="hindiMenuUpload"
              accept=".xlsx, .xls"
              style={{ display: "none" }} 
              onChange={onUploadHindiMenu}
            />
            <label
              htmlFor="hindiMenuUpload"
              className=" bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300 cursor-pointer"
            >
              Upload
            </label>
            {/* <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Upload Hindi Menu
            </h4>
            <p className="text-gray-600 mt-2">
              Upload your Hindi menu in PDF format.
            </p>
            <button onClick={onUploadHindiMenu} className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
              Upload
            </button> */}
          </div>
        </div>

        {/* Upload English Menu Card */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg border border-blue-100 hover:border-blue-200 transition duration-300">
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 mx-auto text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
              />
            </svg>
            {/* <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Upload English Menu
            </h4>
            <p className="text-gray-600 mt-2">
              Upload your English menu in PDF format.
            </p>
            <button onClick={onUploadEnglishMenu} className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300">
              Upload
            </button> */}
             <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Upload English Menu
            </h4>
            <p className="text-gray-600 mt-2 mb-4">
              Upload your English menu in Excel format.
            </p>
            <input
              type="file"
              id="englishMenuUpload"
              accept=".xlsx, .xls"
              style={{ display: "none" }} 
              onChange={onUploadEnglishMenu}
            />
            <label
              htmlFor="englishMenuUpload"
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300 cursor-pointer"
            >
              Upload
            </label>
          </div>
        </div>

        {/* Download Hindi Menu Card */}
        <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-lg border border-green-100 hover:border-green-200 transition duration-300">
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 mx-auto text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Download Indian Menu
            </h4>
            <p className="text-gray-600 mt-2">
              Download your Indian menu in Excel format.
            </p>
            <button onClick={onDownloadHindiMenu} className="mt-4 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition duration-300">
              Download
            </button>
          </div>
        </div>

        {/* Download English Menu Card */}
        <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-lg border border-green-100 hover:border-green-200 transition duration-300">
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 mx-auto text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <h4 className="text-xl font-semibold text-gray-800 mt-4">
              Download English Menu
            </h4>
            <p className="text-gray-600 mt-2">
              Download your English menu in Excel format.
            </p>
            <button onClick={onDownloadEnglishMenu} className="mt-4 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition duration-300">
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuUploadDownload;
